import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function TagsFolderImage(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      width={width || 97.491}
      height={height || 81.536}
      viewBox="0 0 97.491 81.536"
    >
      <path
        d="M19.955 22.247H93.32a1.5 1.5 0 011.5 1.5v49.118a5 5 0 01-5 5H19.955a5 5 0 01-5-5V27.247a5 5 0 015-5z"
        fill="#fee0c0"
      />
      <path
        d="M5.005 81.536A5.592 5.592 0 010 76.009V5.562A5.6 5.6 0 015.622 0h22.491a5.6 5.6 0 015.622 5.562 1.866 1.866 0 001.875 1.853h52.478a5.6 5.6 0 015.622 5.562v5.9a5.581 5.581 0 013.749 5.223v28.921l.031.02v23.5a5 5 0 01-5 5zm9.988-53.728V72.3a5.517 5.517 0 00.08.937 5 5 0 004.986 4.628H88.78a5.005 5.005 0 005-5V39.483a4.99 4.99 0 00-.068-.828V24.1a1.867 1.867 0 00-1.874-1.854H20.616a5.6 5.6 0 00-5.623 5.562zM3.749 5.562v70.447a1.865 1.865 0 001.874 1.853h7.546a9.163 9.163 0 01-1.924-5.562V27.808a9.171 9.171 0 012.749-6.551 9.375 9.375 0 016.623-2.719h69.345v-5.561a1.867 1.867 0 00-1.874-1.854H35.61a5.6 5.6 0 01-5.623-5.561 1.867 1.867 0 00-1.874-1.854H5.622a1.867 1.867 0 00-1.873 1.854z"
        fill="#fb972e"
      />
      <g>
        <g fill="#fff" strokeLinecap="round">
          <path
            d="M14.454 8.976a4.142 4.142 0 01-2.948-1.22L-.28-4.03C-.986-4.737-1.5-5.977-1.5-6.978V-18.33c0-2.3 1.87-4.17 4.17-4.17h11.352c.29 0 .599.043.91.121l-.122-.121h6.332c1 0 2.24.514 2.948 1.221L35.874-9.494a4.174 4.174 0 010 5.897L24.522 7.755a4.142 4.142 0 01-2.949 1.221 4.142 4.142 0 01-2.948-1.22l-.02-.021-.591-.591-.611.611a4.143 4.143 0 01-2.949 1.221zM6.23-15.94a1.171 1.171 0 000 2.34 1.171 1.171 0 000-2.34z"
            transform="translate(37.146 37.228) translate(0 21)"
          />
          <path
            d="M2.67-21A2.67 2.67 0 000-18.33v11.352c0 .61.35 1.456.782 1.888L12.566 6.695a2.661 2.661 0 001.888.781c.683 0 1.367-.26 1.888-.781L27.695-4.658a2.67 2.67 0 000-3.776L15.91-20.218c-.432-.432-1.277-.782-1.888-.782H2.67m3.56 8.899a2.67 2.67 0 110-5.34 2.67 2.67 0 010 5.34M18.431-21l10.914 10.915a4.973 4.973 0 011.466 3.54c0 1.336-.52 2.593-1.466 3.539l-9.68 9.68.02.02a2.661 2.661 0 001.887.782c.683 0 1.367-.26 1.888-.781L34.814-4.658a2.67 2.67 0 000-3.776L23.029-20.218c-.431-.432-1.277-.782-1.888-.782h-2.71M2.67-24h18.472c1.404 0 3.015.667 4.008 1.66l11.785 11.785a5.676 5.676 0 010 8.018L25.582 8.816a5.633 5.633 0 01-4.009 1.66 5.627 5.627 0 01-3.56-1.255 5.627 5.627 0 01-3.559 1.255 5.632 5.632 0 01-4.009-1.66L-1.339-2.97C-2.333-3.962-3-5.573-3-6.978V-18.33A5.676 5.676 0 012.67-24z"
            fill="#fb972e"
            transform="translate(37.146 37.228) translate(0 21)"
          />
        </g>
      </g>
    </svg>
  );
}
